import { get } from '../../01-helpers/services/ajax';

export default function getOrganisation(memberId) {    
    return get(
        '/umbraco/api/relationapi/getorganisation?MemberId=' + memberId
    )
};
